import classNames from 'classnames';
export default function ForbiddenIcon({ size = 20, color, className }) {
    return (<svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames(className, color)}>
      <circle cx="5" cy="5" r="4.25" stroke="currentColor" strokeWidth="1"/>
      <line x1="1.99" y1="8.01" x2="8.01" y2="1.99" stroke="currentColor" strokeWidth="1"/>
    </svg>);
}
